import * as types from './types';
import * as time from '../../../../helpers/time';

export const state = {
  metrics: {
    box_hits: 0,
    conclusion_average_time: 0,
    conclusion_rate: 0,
    completed_submissions_count: 0,
    uncompleted_submissions_count: 0,
    details: [
      {
        user_agent: 'others',
        box_hits: 0,
        conclusion_average_time: 0,
        conclusion_rate: 0,
        unanswered_submissions_count: 0,
        completed_submissions_count: 0,
        uncompleted_submissions_count: 0,
      },
      {
        user_agent: 'mobile',
        box_hits: 0,
        conclusion_average_time: 0,
        conclusion_rate: 0,
        unanswered_submissions_count: 0,
        completed_submissions_count: 0,
        uncompleted_submissions_count: 0,
      },
      {
        user_agent: 'desktop',
        box_hits: 0,
        conclusion_average_time: 0,
        conclusion_rate: 0,
        unanswered_submissions_count: 0,
        completed_submissions_count: 0,
        uncompleted_submissions_count: 0,
      },
      {
        user_agent: 'tablet',
        box_hits: 0,
        conclusion_average_time: 0,
        conclusion_rate: 0,
        unanswered_submissions_count: 0,
        completed_submissions_count: 0,
        uncompleted_submissions_count: 0,
      },
    ],
  },
  boxId: '',
};

export const mutations = {
  [types.METRICS_SET_DATA](state, data) {
    const conclusionRate = (data.conclusion_rate * 100).toFixed(2);
    data.conclusion_average_time = time.toString(data.conclusion_average_time);
    data.conclusion_rate = `${conclusionRate}%`;

    data.details.forEach((device) => {
      const averageTime = device.conclusion_average_time;
      const conclusionRateOfDevice = (device.conclusion_rate * 100).toFixed(2);
      device.conclusion_average_time = time.toString(averageTime);
      device.conclusion_rate = `${conclusionRateOfDevice}%`;
    });

    state.metrics = data;
  },
  [types.METRICS_RESET_STATE](state) {
    state.metrics = {};
    state.boxId = '';
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/metrics/mutations.js
 **/